import maxscript from "refractor/maxscript";
export default maxscript;